import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from "react-accessible-accordion";

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 0 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired
};

const styles = theme => ({
  root: {
    flexGrow: 1,
    margin: "60px 0 20px"
  },
  tabz: {
    borderBottom: "2px solid #e8e8e8",
      margin: "0 0 30px"
  },
  flexContainer: {
    margin: "0 0 20px"
  },
  tabsRoot: {
    fontFamily: ["Fira Sans", "sans-serif"].join(","),
    color: "#188d76",
    fontSize: "16px",
    opacity: "0.7"
  },
  tabsIndicator: {
    height: 3,
    backgroundColor: "#188d76",
    opacity: 1
  },
  tabRoot: {
    textTransform: "initial",
    // "&$tabSelected": {
    //   color: "#188d76",
    //   opacity: "1"
    // },
    "&:focus": {
      color: "#40a9ff"
    }
  }
});

class ScrollableTabs extends Component {
  state = {
    value: "one"
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  componentDidMount() {}

  render() {
    const { classes } = this.props;
    const { value } = this.state;
    return (
      <section className="clearfix fadeInUp questions">
        <div className="container">
          <div className="title-1">
            Frequently <br /> Asked Questions
          </div>
          <div className="content">
            <div>
              <div className={classes.root}>
                <div className={classes.tabz}>
                  <Tabs
                    value={value}
                    onChange={this.handleChange}
                    variant="scrollable"
                    scrollButtons="off"
                    classes={{
                      indicator: classes.tabsIndicator,
                      selected: classes.selected
                    }}
                  >
                    <Tab
                      value="one"
                      classes={{
                        root: classes.tabsRoot,
                        selected: classes.selected
                      }}
                      label="General Questions"
                    />
                    {/* <Tab
                      value="two"
                      classes={{
                        root: classes.tabsRoot,
                        indicator: classes.tabsIndicator
                      }}
                      label="Marketing Tools"
                    />
                    <Tab
                      value="three"
                      classes={{
                        root: classes.tabsRoot,
                        indicator: classes.tabsIndicator
                      }}
                      label="Miscellaneous"
                    />
                    <Tab
                      value="four"
                      classes={{
                        root: classes.tabsRoot,
                        indicator: classes.tabsIndicator
                      }}
                      label="My Account"
                    /> */}
                  </Tabs>
                </div>
                {value === "one" && (
                  <TabContainer>
                    <Accordion>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Does becoming an affiliate bring along any costs on my part?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            No, registering as an affiliate and driving traffic and promoting our products does come without any cost.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            What does being an affiliate mean?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            An affiliate program stands on the principle of an online merchant (in this case, us) paying you a certain proportion of the revenue acquired through the user traffic you have directed to them. The traffic generated can be driven both online and/or offline.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            What methods do you provide for paying revenue shares?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            Our default options are Neteller, Skrill and Wire Transfer. Yet, we do provide other payment methods depending on the region and other details.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Is the data real-time?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            The data is updated within intervals of variable minutes. That being said, the maximum update interval is 6 minutes.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                    </Accordion>
                  </TabContainer>
                 )}
                 {/*
                {value === "two" && (
                  <TabContainer>
                    <Accordion>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            What harsh truths do you prefer to ignore?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            Exercitation in fugiat est ut ad ea cupidatat ut in
                            cupidatat occaecat ut occaecat consequat est minim
                            minim esse tempor laborum consequat esse adipisicing
                            eu reprehenderit enim.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Is free will real or just an illusion?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            In ad velit in ex nostrud dolore cupidatat
                            consectetur ea in ut nostrud velit in irure cillum
                            tempor laboris sed adipisicing eu esse duis nulla
                            non.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                    </Accordion>
                  </TabContainer>
                )}
                {value === "three" && (
                  <TabContainer>
                    <Accordion>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Is free will real or just an illusion?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            In ad velit in ex nostrud dolore cupidatat
                            consectetur ea in ut nostrud velit in irure cillum
                            tempor laboris sed adipisicing eu esse duis nulla
                            non.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                    </Accordion>
                  </TabContainer>
                )}
                {value === "four" && (
                  <TabContainer>
                    <Accordion>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            What harsh truths do you prefer to ignore?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            Exercitation in fugiat est ut ad ea cupidatat ut in
                            cupidatat occaecat ut occaecat consequat est minim
                            minim esse tempor laborum consequat esse adipisicing
                            eu reprehenderit enim.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                    </Accordion>
                  </TabContainer>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

ScrollableTabs.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ScrollableTabs);
